import { FC } from "react";

import {
  AutomationItem,
  AutomationLookupOptions,
} from "./automation.constants";
import { AutomationCard } from "./AutomationCard";

type Props = {
  automations: AutomationItem[];
  workName: string;
  options: AutomationLookupOptions;
  isLoading: boolean;
  isError: boolean;
  deletingAutomationIds: ReadonlySet<string>;
  onDelete: (automation: AutomationItem) => void;
};

const AutomationEmptyState: FC<Pick<Props, "isLoading" | "isError">> = ({
  isLoading,
  isError,
}) => {
  if (isLoading) {
    return (
      <div
        className={
          "rounded-lg border border-dashed border-gray-300 bg-white p-6 text-center text-sm text-gray-500"
        }>
        Loading automations...
      </div>
    );
  }

  if (isError) {
    return (
      <div
        className={
          "rounded-lg border border-red-100 bg-red-50 p-6 text-center text-sm text-red-700"
        }>
        Automations could not be loaded. Please try again.
      </div>
    );
  }

  return (
    <div
      className={
        "rounded-lg border border-dashed border-gray-300 bg-white p-6 text-center text-sm text-gray-500"
      }>
      No automations added yet.
    </div>
  );
};

export const AutomationList: FC<Props> = ({
  automations,
  workName,
  options,
  isLoading,
  isError,
  deletingAutomationIds,
  onDelete,
}) => {
  if (isLoading) {
    return <AutomationEmptyState isLoading={isLoading} isError={isError} />;
  }

  if (automations.length === 0) {
    return <AutomationEmptyState isLoading={isLoading} isError={isError} />;
  }

  return (
    <div className={"grid gap-3"}>
      {automations.map((automation) => (
        <AutomationCard
          key={automation.id}
          automation={automation}
          workName={workName}
          options={options}
          isDeleting={deletingAutomationIds.has(automation.id)}
          hideWorkItemTitle
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
